import React from "react";
import Logo from "~/components/HeaderMinimus/Logo";
import SignIn from "~/components/SignIn";
import { SHIRTSPACE_PHONE, SHIRTSPACE_SALES_EMAIL } from "~/constants";
import { useHydrated } from "~/hooks/useHydrated";
import { formatPhoneNumber } from "~/utils/text";
import "./styles.css";

const HeaderMinimus: React.FC<{
  hasSession: boolean;
  isNewWizard?: boolean;
}> = ({ hasSession, isNewWizard }) => {
  const [iconDropdownActive, setIconDropdownActive] =
    React.useState<boolean>(false);
  const isHydrated = useHydrated();

  return (
    <header
      className="header"
      data-test-id="header"
    >
      <div className="header__inner">
        <Logo white={true} />
        <div className="header__contact">
          {isHydrated ? (
            <>
              <span>{SHIRTSPACE_SALES_EMAIL}</span>
              <span role="presentation">|</span>
            </>
          ) : null}
          <span>{formatPhoneNumber(SHIRTSPACE_PHONE)}</span>
        </div>
        <SignIn
          color="white"
          isDropdownActive={iconDropdownActive}
          setIsDropdownActive={setIconDropdownActive}
          hasSession={hasSession}
          isNewWizard={isNewWizard}
        />
      </div>
    </header>
  );
};

export default HeaderMinimus;
